import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { useTheme } from "@mui/material/styles";
import {ReactComponent as MoreOptionIcon} from '../../assets/img/more_option.svg';

export default function MoreOptionButton({ onClick }) {
  const theme = useTheme();
  const [anchorNotification, setAnchorNotification] = useState(null);

  function handleClick(event) {
    setAnchorNotification(event.currentTarget);
  }

  const handleClose = () => () => {
    setAnchorNotification(null);
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip title="More Options" placement="top" enterTouchDelay={0}>
        <IconButton
          onClick={(e) => handleClick(e)}
          sx={{
            color: '#a1a5b7',
            "&:hover": {
              backgroundColor: theme.palette.mode === 'light' ? '#f1faff' : '#212e48',
              borderRadius: '6px',
            },
            "&:hover svg": {
              color: '#009ef7',
            },
          }}
        >
          <MoreOptionIcon style={{ width: '20px', height: '20px' }} />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '40px' }}
        anchorEl={anchorNotification}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorNotification)}
        onClose={handleClose()}
        PaperProps={{
          sx: {
            ".MuiList-root": { padding: '0!important' }
          },
        }}
      >
        <MenuItem>
          <Button
            onClick={() => {
              setAnchorNotification(null);
              onClick();
            }}
            variant="text"
            sx={{
              color: '#7E8299',
              fontSize: 14,
              fontWeight: 'bold',
              paddingInlineEnd: 5,
            }}
          >
            Delete
          </Button>
        </MenuItem>
      </Menu>
    </Box>
  );
}
